// Sync ACF Colour Picker colour options with Themes registered Colour Palette
acf.addFilter("color_picker_args", function (args) {
	// Get Block Editor Settings
	const settings = wp.data.select("core/editor").getEditorSettings();

	// Get Theme Colour Palette
	const colors = settings.colors.map((color) => {
		console.log(color);

		// remove var( ) from color value
		const colorValue = color.color.replace(/var\(([^)]+)\)/g, "$1");
		console.log(colorValue);
		return getComputedStyle(document.querySelector(".editor-styles-wrapper")).getPropertyValue(colorValue);
	});

	// Get Individual Colours
	args.palettes = colors;

	// Add Colours to the ACF Colour Picker field
	return args;
});

wp.blocks.registerBlockVariation("core/group", {
	isDefault: true,
	attributes: {
		layout: {
			inherit: true,
		},
	},
});

// Append the loaded attribute so animations work
wp.domReady(() => {
	document.querySelector(".editor-styles-wrapper").setAttribute("data-s-loaded", "");
});
